if (!customElements.get("c-pdp-popup")) {
  customElements.define(
    "c-pdp-popup",
    class SectionPopupImage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const mainProduct = document.querySelector(".js-main-product");

        if (mainProduct) {
          mainProduct.appendChild(this);
        }

        this.closeButton = this.querySelector(".js-pdp-popup__close");
        this.overlay = this.querySelector(".js-pdp-popup__overlay");
        this.popupOpener = document.querySelector(`#js-${this.dataset.blockId}--pdp-popup-opener`);

        if (this.popupOpener) {
          this.popupOpener.addEventListener("click", this.showPopup);
        }

        this.overlay.addEventListener("click", this.closePopup);
        this.closeButton.addEventListener("click", this.closePopup);
      }

      disconnectedCallback() {
        if (this.popupOpener) {
          this.popupOpener.removeEventListener("click", this.showPopup);
        }

        this.overlay.removeEventListener("click", this.closePopup);
        this.closeButton.removeEventListener("click", this.closePopup);
      }

      showPopup = () => {
        this.classList.add("is-active");
      };

      closePopup = () => {
        this.classList.remove("is-active");
      };
    }
  );
}
